import { Helmet } from 'react-helmet';

import { PageHeader } from 'shared-components';

import ChecklistSection from '../../../atoms/checklist-section';
import Finger, { Status } from '../../../atoms/finger';
import PageSubtext from '../../../atoms/PageSubtext';
import { titleAppend } from '../../../../utilities/head';
import { useDispatch, useSelector } from 'react-redux';
import { createNavigateToAction } from '../../../../middleware/actions';
import { ApplicationState } from '../../../../store';

const Interview = () => {
  const dispatch = useDispatch();

  const preCasInterview = useSelector((state: ApplicationState) => state.student.preCasInterview);
  const title = useSelector((state: ApplicationState) => state.config.sections.PreCASInterview.summaryLabel);
  const summary = useSelector((state: ApplicationState) => state.config.sections.PreCASInterview.summary);

  const PCI1 = preCasInterview && preCasInterview.isPage1Complete ? preCasInterview.isPage1Complete : false;
  const PCI2 = preCasInterview && preCasInterview.isPage2Complete ? preCasInterview.isPage2Complete : false;
  const PCI3 = preCasInterview && preCasInterview.isPage3Complete ? preCasInterview.isPage3Complete : false;
  const PCI4 = preCasInterview && preCasInterview.isPage4Complete ? preCasInterview.isPage4Complete : false;

  const hasStarted = !(PCI1 === false && PCI2 === false && PCI3 === false && PCI4 === false);
  const complete = PCI1 && PCI2 && PCI3 && PCI4;
  const PCI1Status = PCI1 ? Status.Locked : Status.InProgress;
  const PCI2Status = PCI2 ? Status.Locked : PCI1 ? Status.InProgress : Status.Todo;
  const PCI3Status = PCI3 ? Status.Locked : PCI2 ? Status.InProgress : Status.Todo;
  const PCI4Status = PCI4 ? Status.Locked : PCI3 ? Status.InProgress : Status.Todo;

 
  const onResume = (url: string) => {
    dispatch(createNavigateToAction(url));
  };

  const handleActionClick = (target: string, status: Status) => {
    switch (target) {
      case 'PCI1':
        onResume('/interview/step-1');
        break;
      case 'PCI2':
        onResume('/interview/step-2');
        break;
      case 'PCI3':
        onResume('/interview/step-3');
        break;
      case 'PCI4':
        onResume('/interview/step-4');
        break;
    }
  };
  return (
    <>
      <Helmet>
        <title>
          {title} {titleAppend}
        </title>
      </Helmet>

      <PageHeader dataSelector="Dashboard-Header">{title}</PageHeader>

      <PageSubtext>{summary}</PageSubtext>

      <ChecklistSection id="pre-cas-section" label={'Sections to complete / resume'}>
        <Finger
          id={'PIP1'}
          noEdit={true}
          status={PCI1Status}
          hasStart={!hasStarted && !complete}
          showAction={!hasStarted && !complete}
          label={'Step 1'}
          onClick={() => {
            if (!hasStarted && !complete) {
              onResume('/interview/section-start');
            } else {
              handleActionClick('PCI1', PCI1Status);
            }
          }}
        />

        <Finger
          id={'PIP2'}
          noEdit={true}
          status={PCI2Status}
          label={'Step 2'}
          onClick={() => handleActionClick('PCI2', PCI2Status)}
        />

        <Finger
          id={'PIP3'}
          noEdit={true}
          status={PCI3Status}
          label={'Step 3'}
          onClick={() => handleActionClick('PCI3', PCI3Status)}
        />

        <Finger
          id={'PIP4'}
          noEdit={true}
          status={PCI4Status}
          label={'Step 4'}
          onClick={() => handleActionClick('PCI4', PCI4Status)}
        />
      </ChecklistSection>
    </>
  );
};

export default Interview;
